<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    required: true,
  },
  info: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  appendInnerIcon: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const update = (event) => {
  const { value } = event.target;
  emit('update:modelValue', value);
};

const fieldValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <div>
    <v-text-field
      v-model="fieldValue"
      v-bind="$attrs"
      :type="type"
      :label="label"
      :disabled="disabled"
      :append-inner-icon="appendInnerIcon"
      @input="update"
    />
  </div>
</template>

<style scoped>

</style>
